import { defineMessages } from 'react-intl';

import { ReportType } from 'protocol/model/dto_report_pb';
import { StudyType } from 'protocol/model/dto_study_pb';

export const studyTypeMessages = defineMessages<StudyType>({
  [StudyType.StudyType_InvalidValue]: {
    id: 'studyType.invalid',
    defaultMessage: 'Unknown',
  },
  [StudyType.StudyType_CBCT]: {
    id: 'studyType.cbct',
    defaultMessage: 'CBCT',
  },
  [StudyType.StudyType_IntraoralXRay]: {
    id: 'studyType.intraoralXRay',
    defaultMessage: 'Intraoral X-Ray',
  },
  [StudyType.StudyType_PanoramicXRay]: {
    id: 'studyType.panoramicXRay',
    defaultMessage: 'Panoramic X-Ray',
  },
  [StudyType.StudyType_IOS_Meshes]: {
    id: 'studyType.iosMeshes',
    defaultMessage: 'IOS Meshes',
  },
  [StudyType.StudyType_DentalPhoto]: {
    id: 'studyType.dentalPhoto',
    defaultMessage: 'Dental Photo',
  },
});

export const reportTypeMessages = defineMessages<ReportType>({
  [ReportType.ReportType_InvalidValue]: {
    id: 'reportType.invalid',
    defaultMessage: 'Unknown',
  },
  [ReportType.ReportType_CBCT_GP]: {
    id: 'reportType.cbctGp',
    defaultMessage: 'CBCT GP',
  },
  [ReportType.ReportType_CBCT_Segmentation]: {
    id: 'reportType.cbctSegmentation',
    defaultMessage: 'CBCT Segmentation',
  },
  [ReportType.ReportType_CBCT_OrthoSlides]: {
    id: 'reportType.cbctOrthoSlides',
    defaultMessage: 'CBCT Ortho Slides',
  },
  [ReportType.ReportType_CBCT_Implant]: {
    id: 'reportType.cbctImplant',
    defaultMessage: 'CBCT Implant',
  },
  [ReportType.ReportType_CBCT_Endo]: {
    id: 'reportType.cbctEndo',
    defaultMessage: 'CBCT Endo',
  },
  [ReportType.ReportType_CBCT_Molar]: {
    id: 'reportType.cbctMolar',
    defaultMessage: 'CBCT Molar',
  },
  [ReportType.ReportType_Pano_GP]: {
    id: 'reportType.panoGp',
    defaultMessage: 'Panoramic GP',
  },
  [ReportType.ReportType_IOXRay_GP]: {
    id: 'reportType.ioxRayGp',
    defaultMessage: 'IO X-Ray GP',
  },
  [ReportType.ReportType_DentalPhoto_GP]: {
    id: 'reportType.dentalPhotoGp',
    defaultMessage: 'Dental Photo GP',
  },
  [ReportType.ReportType_IOS_Segmentation]: {
    id: 'reportType.iosSegmentation',
    defaultMessage: 'IOS Segmentation',
  },
  [ReportType.ReportType_CBCT_IOS_Superimposition]: {
    id: 'reportType.cbctIosSuperimposition',
    defaultMessage: 'CBCT/IOS Superimposition',
  },
  [ReportType.ReportType_StudioImplant]: {
    id: 'reportType.studioImplant',
    defaultMessage: 'Studio Implant',
  },
  [ReportType.ReportType_Photo_Ortho]: {
    id: 'reportType.photoOrtho',
    defaultMessage: 'Photo Ortho',
  },
  [ReportType.ReportType_StudioOrtho]: {
    id: 'reportType.studioOrtho',
    defaultMessage: 'Studio Ortho',
  },
  [ReportType.ReportType_Pano_Bitewings]: {
    id: 'reportType.panoBitewings',
    defaultMessage: 'Panoramic Bitewings',
  },
});

